<template lang="pug">
section.LndClients.d-flex.--col
  .__clients.d-flex.--middle
    .__desc
      h2 {{ L.header }}
      p {{ L.text }}
    .__list.d-flex.--wrap(style="--gap-v:30px; --gap-h: 30px")
      a(v-for="item of L.list")
        img(:src="logos[item.$logo]", :alt="item.$logo")

  .__partners.d-flex.--middle
    .__desc
      h2 {{ L.header2 }}
      p {{ L.text2 }}
    .__list.d-flex.--wrap(style="--gap-v:30px; --gap-h: 30px")
      a(v-for="item of L.list2")
        img(:src="logos[item.$logo]", :alt="item.$logo")

  slot

</template>
<script>
import content, { logos } from 'content';

export default {
  name: 'LndClients',

  static: () => ({
    L: content.clients,
    logos,
  }),
};

</script>
<style>
.LndClients {
  --gap-v: calc(110 / var(--vw-scale));

  padding-bottom: 50px;

  .__desc {
    display: inline-block;

    margin-right: 64px !important;
    padding-right: 36px;

    border-right: 1px solid var(--sep-c);

    h2 {
      margin-bottom: 16px;
    }

    p {
      display: block;
      width: 253px;

      line-height: 35px;
    }

    .__img {
      flex-grow: 0;
      flex-shrink: 0;
    }
  }

  .__list {
    display: flex-inline;
    max-width: 600px;

    a {
      flex-basis: 120px;

      /*img {
        filter: grayscale(1) opacity(.8);
        transition: all 3s;
      }

      &:hover img {
        filter: grayscale(0) opacity(1);
        transform: scale(1.1);
        transition-duration: .2s;
      }*/
    }

    img {
      max-width: 100px;
      height: 18px;

      &[alt="twitter"] { height: 14px }
    }
  }

  [alt="prisma"],
  [alt="sephora"],
  [alt="fb"] { height: 12px }
}

@media (max-width:  739px) {
  .LndClients {
    --gap-v: 80px;

    .__desc {
      border-right: 0;

      p {
        width: auto;
        margin-bottom: 50px;
      }
    }

    .__clients,
    .__partners {
      flex-direction: column;
      align-items: flex-start;
    }

    .__list {
      &:not(:last-child) { margin-bottom: 100px; }

      a {
        flex-basis: 40%;

        opacity: .7;
      }
    }
  }

}
</style>
